// TODO: При возможности обновить turf до v6+ и использовать встроенную pointToLineDistance
// В текущей версии turf (v3) pointOnLine находит ближайшую вершину, а не проекцию на ребро
// Важно: все расчеты тут через гаверсинусы, а рисование происходит в обычных прямоугольных
// координатах, поэтому на очень больших растояниях будет рассинхрон

const { PI, sin, cos, atan2, sqrt, max, min } = Math
const DEG = PI / 180
const R = 6371000 // Радиус Земли в метрах

/**
 * Расстояние по гаверсинусу между двумя точками [lng, lat] в метрах
 */
const haversineMeters = (a: [number, number], b: [number, number]): number => {
  const [lng1, lat1] = a
  const [lng2, lat2] = b
  const dLat = (lat2 - lat1) * DEG
  const dLng = (lng2 - lng1) * DEG
  const s = sin(dLat / 2)
  const c1 = cos(lat1 * DEG)
  const c2 = cos(lat2 * DEG)
  const sl = sin(dLng / 2)
  const h = s * s + c1 * c2 * sl * sl
  return R * 2 * atan2(sqrt(h), sqrt(1 - h))
}

/**
 * Расстояние от точки P до отрезка AB в метрах.
 * Проекция считается в плоском 2D-пространстве координат [lng, lat],
 * финальное расстояние — по гаверсинусу.
 */
const pointToSegmentMeters = (p: [number, number], a: [number, number], b: [number, number]): number => {
  const abX = b[0] - a[0]
  const abY = b[1] - a[1]
  const apX = p[0] - a[0]
  const apY = p[1] - a[1]
  const ab2 = abX * abX + abY * abY

  if (ab2 === 0) return haversineMeters(p, a)

  const t = max(0, min(1, (apX * abX + apY * abY) / ab2))
  return haversineMeters(p, [a[0] + t * abX, a[1] + t * abY])
}

/**
 * Минимальное расстояние от точки [lng, lat] до границы полигона в метрах.
 * Перебирает все рёбра внешнего кольца и возвращает минимум.
 */
export const pointToPolygonMeters = (point: [number, number], polygonCoords: [number, number][][]): number => {
  const ring = polygonCoords[0] // внешнее кольцо
  let minDist = Infinity

  for (let i = 0; i < ring.length - 1; i++) {
    const dist = pointToSegmentMeters(point, ring[i], ring[i + 1])
    if (dist < minDist) minDist = dist
  }

  return minDist
}

export const getPercentComplete = (progress: number | undefined, overall: number | undefined) => {
  if (progress === undefined || overall === undefined) return ''

  return Math.round((progress / overall) * 100)
}
